class OrderEdge {
  static cunt = (x) => {
    console.log(x);
  }


}
export default OrderEdge;



// WEBPACK FOOTER //
// ./src/OrderEdge.js